import React, { useState, useEffect } from "react";
import { HashLink as Link } from "react-router-hash-link";
import logo from "./../../assets/img/logo.svg";

const Nav = () => {
  // --- ÉTAT pour le menu burger ---
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // --- FONCTION de toggle ---
  const toggleMenu = () => {
    if (isOpen) {
      // on est en train de fermer
      setIsClosing(true);
      setTimeout(() => {
        setIsOpen(false);
        setIsClosing(false);
      }, 300); // Durée identique à l'animation CSS
    } else {
      // on ouvre direct
      setIsOpen(true);
    }
  };

  // --- Empêcher le scroll quand le menu mobile est ouvert ---
  useEffect(() => {
    if (isOpen && !isClosing) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen, isClosing]);

  return (
    <header className="nav-header">
      <div className="nav-container">
        {/* Logo à gauche */}
        <Link to="/#hero" className="logo-link">
          <img src={logo} alt="Logo UP4M" className="nav-logo" />
        </Link>

        {/* Menu Desktop (caché en mobile via CSS) */}
        <nav className="nav-menu">
          <Link to="/#about" className="nav-link">
            À PROPOS
          </Link>
          <Link to="/formations/#formation-hero" className="nav-link">
            NOS FORMATIONS
          </Link>
          <Link to="/#entreprise" className="nav-link">
            ENTREPRISES
          </Link>
          <Link to="/contact/#contact" className="nav-link">
            CONTACT
          </Link>
        </nav>

        {/* BOUTON BURGER (s’affiche sur mobile) */}
        <button
          className={`burger ${isOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* MENU MOBILE (si ouvert ou fermeture en cours) */}
      {(isOpen || isClosing) && (
        <nav className={`mobile-menu ${isOpen ? "open" : "closing"}`}>
          <Link to="/#about" className="nav-link" onClick={toggleMenu}>
            À PROPOS
          </Link>
          <Link
            to="/formations/#formation-hero"
            className="nav-link"
            onClick={toggleMenu}
          >
            NOS FORMATIONS
          </Link>
          <Link to="/#entreprise" className="nav-link" onClick={toggleMenu}>
            ENTREPRISES
          </Link>
          <Link
            to="/contact/#contact"
            className="nav-link"
            onClick={toggleMenu}
          >
            CONTACT
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Nav;
